<div class="max-w-sm w-full bg-white p-5 border-gray-300 border rounded-lg shadow-xl transform transition-all" [ngClass]="gradientColors">
  <h2 class="text-[#3f3f3f] text-xl font-medium">{{title}}</h2>
  <p *ngIf="!loading" class="text-[#3f3f3f] text-4xl mt-2 font-bold">{{info}} <span class="text-sm font-medium" *ngIf="sub_info">{{sub_info}}</span></p>
  <app-loader *ngIf="loading" size="extra-small"></app-loader>
  <div class="flex justify-between items-center">
    <!-- Icono -->
    <!--<div class="text-white text-3xl p-2 rounded-full" [ngClass]="iconBgColor">
      <ng-content></ng-content>
    </div> -->
    <!-- Etiqueta de tiempo o estado -->
    <span class="text-white text-sm font-medium px-3 py-1 mt-3 rounded-full" [ngClass]="dateBgColor">{{ dates }}</span>
  </div>
  <!--<div class="mt-6">
    &lt;!&ndash; Botón de acción &ndash;&gt;
    <button class="px-4 py-2 bg-indigo-700 text-white rounded-full hover:bg-indigo-600 transition-colors duration-200">
      Ver más
    </button>
  </div>-->
</div>
